import React from 'react';
import {useParams} from "react-router-dom";
import {withFirebase} from '../Firebase';
import {AuthUserContext, withAuthorization} from '../Session';
import './aiKnowledgeBase.css';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';


const AIKnowledgeBasePage = ({fakeUid}) => {
    const {uid} = useParams();
    return (
        <AuthUserContext.Consumer>
            {authUser => {
                return (
                    <div className="min-h-screen bg-gray-50">
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                            {/* Page Header */}
                            <div className="mb-6">
                                <h1 className="text-2xl font-bold text-gray-900">AI Baza Znanja</h1>
                                <p className="text-gray-600 mt-1">Upravljanje znanjem za AI asistenta koji odgovara na pitanja kupaca</p>
                            </div>
                            <AIKnowledgeBaseContent authUser={authUser} uid={uid} fakeUid={fakeUid}/>
                        </div>
                    </div>
                );
            }}
        </AuthUserContext.Consumer>
    )
};

let useUID;

class AIKnowledgeBaseContentBase extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.fakeUid) {
            useUID = this.props.fakeUid;
        } else {
            useUID = this.props.authUser.uid;
        }

        this.state = {
            company: null,
            loading: false,
            knowledgeFiles: [],
            loadingKnowledge: false,
            uploadingKnowledge: false,
            newKnowledgeTitle: '',
            newKnowledgeCategory: 'general',
            newKnowledgeContent: '',
            knowledgeError: null,
            deletingKnowledge: null,
            selectedFile: null,
            isDragOver: false,
            inputMode: 'file', // 'file' or 'text'
            // Knowledge level state
            knowledgeLevel: 'company', // 'company', 'campaignType', 'campaign'
            selectedCampaignType: '',
            selectedCampaignId: '',
            manualCampaignId: '',
            useManualCampaignId: false,
            campaigns: [],
            loadingCampaigns: false,
            // Campaign types (user-defined)
            campaignTypes: [],
            loadingCampaignTypes: false,
            newCampaignTypeInput: '',
            showAddCampaignType: false,
            // View filter
            viewLevel: 'company',
            viewCampaignType: '',
            viewCampaignId: '',
            // Test users
            testUsers: [],
            newTestUserUid: '',
            addingTestUser: false,
            removingTestUser: null
        };

        this.fetchKnowledgeFiles = this.fetchKnowledgeFiles.bind(this);
        this.addTestUser = this.addTestUser.bind(this);
        this.removeTestUser = this.removeTestUser.bind(this);
        this.uploadKnowledge = this.uploadKnowledge.bind(this);
        this.deleteKnowledge = this.deleteKnowledge.bind(this);
        this.handleFileSelect = this.handleFileSelect.bind(this);
        this.handleFileDrop = this.handleFileDrop.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleDragLeave = this.handleDragLeave.bind(this);
        this.uploadKnowledgeFromFile = this.uploadKnowledgeFromFile.bind(this);
        this.processSelectedFile = this.processSelectedFile.bind(this);
        this.fetchCampaigns = this.fetchCampaigns.bind(this);
        this.fetchCampaignTypes = this.fetchCampaignTypes.bind(this);
        this.addCampaignType = this.addCampaignType.bind(this);
        this.handleLevelChange = this.handleLevelChange.bind(this);
    }

    componentDidMount() {
        this.setState({loading: true});

        // Fetch company data
        this.companyUnsub = this.props.firebase.company(useUID).onSnapshot(docSnapshot => {
            const companyData = docSnapshot.data();
            this.setState({
                company: companyData,
                loading: false,
                testUsers: companyData?.aiKnowledgeTestUsers || []
            });
        }, err => {
            console.log(`Encountered error: ${err}`);
            this.setState({loading: false});
        });

        // Fetch knowledge files
        this.fetchKnowledgeFiles();

        // Fetch campaigns for dropdown
        this.fetchCampaigns();

        // Fetch user-defined campaign types
        this.fetchCampaignTypes();
    }

    componentWillUnmount() {
        if (this.companyUnsub) this.companyUnsub();
    }

    async fetchCampaigns() {
        this.setState({loadingCampaigns: true});
        try {
            const snapshot = await this.props.firebase.db
                .collection('company').doc(useUID)
                .collection('campaign')
                .orderBy('time', 'desc')
                .limit(10)
                .get();

            const campaigns = [];
            snapshot.forEach(doc => {
                const data = doc.data();
                // Extract text preview from offer (strip HTML tags)
                let offerPreview = '';
                const offerField = data.offer || data.offerValue || '';
                if (offerField) {
                    offerPreview = offerField
                        .replace(/<[^>]*>/g, '') // Remove HTML tags
                        .substring(0, 40)
                        .trim();
                    if (offerField.length > 40) offerPreview += '...';
                }
                campaigns.push({
                    id: doc.id,
                    offerPreview: offerPreview || `Kampanja ${doc.id.substring(0, 8)}`,
                    campaignType: data.campaignType || '',
                    time: data.time
                });
            });

            console.log('Fetched campaigns:', campaigns.length);
            this.setState({campaigns, loadingCampaigns: false});
        } catch (error) {
            console.error('Error fetching campaigns:', error);
            this.setState({loadingCampaigns: false});
        }
    }

    async fetchCampaignTypes() {
        this.setState({loadingCampaignTypes: true});
        try {
            // Fetch campaign types from the aiKnowledge/data/campaignTypes subcollection
            const snapshot = await this.props.firebase.db
                .collection('company').doc(useUID)
                .collection('aiKnowledge').doc('data')
                .collection('campaignTypes')
                .get();

            const campaignTypes = [];
            snapshot.forEach(doc => {
                campaignTypes.push(doc.id);
            });

            // Sort alphabetically
            campaignTypes.sort((a, b) => a.localeCompare(b));

            this.setState({campaignTypes, loadingCampaignTypes: false});
        } catch (error) {
            console.error('Error fetching campaign types:', error);
            this.setState({loadingCampaignTypes: false});
        }
    }

    async addCampaignType() {
        const {newCampaignTypeInput, campaignTypes} = this.state;
        const trimmedType = newCampaignTypeInput.trim().toLowerCase().replace(/\s+/g, '_');

        if (!trimmedType) {
            return;
        }

        // Check if already exists
        if (campaignTypes.includes(trimmedType)) {
            this.setState({
                knowledgeError: 'Ovaj tip kampanje vec postoji.',
                newCampaignTypeInput: ''
            });
            return;
        }

        try {
            // Create a placeholder document in the aiKnowledge/data/campaignTypes collection
            // This ensures the type exists even before any knowledge is added
            await this.props.firebase.db
                .collection('company').doc(useUID)
                .collection('aiKnowledge').doc('data')
                .collection('campaignTypes').doc(trimmedType)
                .set({
                    createdAt: new Date(),
                    name: newCampaignTypeInput.trim()
                }, {merge: true});

            // Update local state
            const newTypes = [...campaignTypes, trimmedType].sort((a, b) => a.localeCompare(b));
            this.setState({
                campaignTypes: newTypes,
                selectedCampaignType: trimmedType,
                newCampaignTypeInput: '',
                showAddCampaignType: false,
                knowledgeError: null
            });
        } catch (error) {
            console.error('Error adding campaign type:', error);
            this.setState({knowledgeError: 'Greska pri dodavanju tipa kampanje.'});
        }
    }

    handleLevelChange(level) {
        this.setState({
            knowledgeLevel: level,
            selectedCampaignType: '',
            selectedCampaignId: ''
        });
    }

    async addTestUser() {
        const {newTestUserUid, testUsers} = this.state;
        const trimmedUid = newTestUserUid.trim();

        if (!trimmedUid) {
            return;
        }

        if (testUsers.includes(trimmedUid)) {
            this.setState({knowledgeError: 'Ovaj korisnik je vec dodat kao test korisnik.'});
            return;
        }

        this.setState({addingTestUser: true, knowledgeError: null});

        try {
            const updatedTestUsers = [...testUsers, trimmedUid];
            await this.props.firebase.company(useUID).update({
                aiKnowledgeTestUsers: updatedTestUsers
            });
            this.setState({
                testUsers: updatedTestUsers,
                newTestUserUid: '',
                addingTestUser: false
            });
        } catch (error) {
            console.error('Error adding test user:', error);
            this.setState({
                knowledgeError: 'Greska pri dodavanju test korisnika.',
                addingTestUser: false
            });
        }
    }

    async removeTestUser(uidToRemove) {
        const {testUsers} = this.state;

        this.setState({removingTestUser: uidToRemove});

        try {
            const updatedTestUsers = testUsers.filter(uid => uid !== uidToRemove);
            await this.props.firebase.company(useUID).update({
                aiKnowledgeTestUsers: updatedTestUsers
            });
            this.setState({
                testUsers: updatedTestUsers,
                removingTestUser: null
            });
        } catch (error) {
            console.error('Error removing test user:', error);
            this.setState({
                knowledgeError: 'Greska pri uklanjanju test korisnika.',
                removingTestUser: null
            });
        }
    }

    async fetchKnowledgeFiles() {
        const {viewLevel, viewCampaignType, viewCampaignId, campaigns, campaignTypes} = this.state;
        this.setState({loadingKnowledge: true});

        try {
            // Base path for all AI knowledge
            const aiKnowledgeRef = this.props.firebase.db
                .collection('company').doc(useUID)
                .collection('aiKnowledge').doc('data');

            const filesMap = new Map();

            // Helper to process chunks and add to filesMap
            const processChunks = (snapshot, level, levelId = '', levelDisplayName = '') => {
                snapshot.forEach(doc => {
                    const data = doc.data();
                    const key = `${level}_${levelId}_${data.sourceFile || data.title || 'Nepoznato'}`;
                    if (!filesMap.has(key)) {
                        filesMap.set(key, {
                            sourceFile: data.sourceFile,
                            title: data.title,
                            category: data.category,
                            chunksCount: 0,
                            createdAt: data.createdAt,
                            level: level,
                            levelId: levelId,  // actual ID for deletion
                            levelDisplayName: levelDisplayName || levelId  // display name for UI
                        });
                    }
                    filesMap.get(key).chunksCount++;
                });
            };

            // Determine what to fetch based on filter
            const shouldFetchAll =
                viewLevel === 'company' ||
                (viewLevel === 'campaignType' && !viewCampaignType) ||
                (viewLevel === 'campaign' && !viewCampaignId);

            if (shouldFetchAll) {
                // Fetch ALL knowledge from all levels
                const fetchPromises = [];

                // 1. Company level chunks
                fetchPromises.push(
                    aiKnowledgeRef.collection('chunks').get()
                        .then(snapshot => processChunks(snapshot, 'company', '', ''))
                );

                // 2. All campaign types chunks
                for (const type of campaignTypes) {
                    fetchPromises.push(
                        aiKnowledgeRef.collection('campaignTypes').doc(type).collection('chunks').get()
                            .then(snapshot => processChunks(snapshot, 'campaignType', type, type))
                    );
                }

                // 3. All campaigns chunks (from last 10 campaigns we have loaded)
                for (const campaign of campaigns) {
                    fetchPromises.push(
                        aiKnowledgeRef.collection('campaigns').doc(campaign.id).collection('chunks').get()
                            .then(snapshot => processChunks(snapshot, 'campaign', campaign.id, campaign.offerPreview))
                    );
                }

                await Promise.all(fetchPromises);

            } else if (viewLevel === 'campaign' && viewCampaignId) {
                // Specific campaign
                const snapshot = await aiKnowledgeRef
                    .collection('campaigns').doc(viewCampaignId)
                    .collection('chunks')
                    .orderBy('createdAt', 'desc')
                    .get();
                const campaign = campaigns.find(c => c.id === viewCampaignId);
                processChunks(snapshot, 'campaign', viewCampaignId, campaign?.offerPreview || viewCampaignId);

            } else if (viewLevel === 'campaignType' && viewCampaignType) {
                // Specific campaign type
                const snapshot = await aiKnowledgeRef
                    .collection('campaignTypes').doc(viewCampaignType)
                    .collection('chunks')
                    .orderBy('createdAt', 'desc')
                    .get();
                processChunks(snapshot, 'campaignType', viewCampaignType, viewCampaignType);
            }

            const knowledgeFiles = Array.from(filesMap.values());
            this.setState({knowledgeFiles, loadingKnowledge: false});
        } catch (error) {
            console.error('Error fetching knowledge files:', error);
            this.setState({loadingKnowledge: false, knowledgeError: 'Greska pri ucitavanju baze znanja.'});
        }
    }

    async uploadKnowledge() {
        const {newKnowledgeTitle, newKnowledgeCategory, newKnowledgeContent, knowledgeLevel, selectedCampaignType, selectedCampaignId, useManualCampaignId, manualCampaignId} = this.state;

        if (!newKnowledgeTitle.trim() || !newKnowledgeContent.trim()) {
            this.setState({knowledgeError: 'Naslov i sadrzaj su obavezni.'});
            return;
        }

        // Validate level-specific requirements
        if (knowledgeLevel === 'campaignType' && !selectedCampaignType) {
            this.setState({knowledgeError: 'Izaberite tip kampanje.'});
            return;
        }

        // Get effective campaign ID (from dropdown or manual input)
        const effectiveCampaignId = useManualCampaignId ? manualCampaignId : selectedCampaignId;
        if (knowledgeLevel === 'campaign' && !effectiveCampaignId) {
            this.setState({knowledgeError: 'Izaberite ili unesite ID kampanje.'});
            return;
        }

        this.setState({uploadingKnowledge: true, knowledgeError: null});

        try {
            const idToken = await this.props.firebase.auth.currentUser.getIdToken();

            const body = {
                companyUid: useUID,
                content: newKnowledgeContent,
                title: newKnowledgeTitle,
                category: newKnowledgeCategory,
                sourceFile: `manual_${Date.now()}_${newKnowledgeTitle.replace(/\s+/g, '_')}`
            };

            // Add level-specific parameters
            if (knowledgeLevel === 'campaignType') {
                body.campaignType = selectedCampaignType;
            } else if (knowledgeLevel === 'campaign') {
                body.campaignId = effectiveCampaignId;
            }

            const response = await fetch('https://europe-west3-digitalna-kartica.cloudfunctions.net/processKnowledgeContent', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${idToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            const result = await response.json();

            if (response.ok && result.success) {
                this.setState({
                    uploadingKnowledge: false,
                    newKnowledgeTitle: '',
                    newKnowledgeCategory: 'general',
                    newKnowledgeContent: '',
                    knowledgeError: null
                });
                alert(`Uspesno dodato ${result.chunksCreated} chunk(s) u bazu znanja.`);
                // Update view to match the level we just uploaded to
                this.setState({
                    viewLevel: knowledgeLevel,
                    viewCampaignType: selectedCampaignType,
                    viewCampaignId: effectiveCampaignId
                }, () => this.fetchKnowledgeFiles());
            } else {
                throw new Error(result.message || 'Greska pri uploadu');
            }
        } catch (error) {
            console.error('Error uploading knowledge:', error);
            this.setState({
                uploadingKnowledge: false,
                knowledgeError: 'Greska pri uploadu: ' + error.message
            });
        }
    }

    async deleteKnowledge(sourceFile, level, levelId) {
        if (!window.confirm('Da li ste sigurni da zelite da obrisete ovo znanje?')) {
            return;
        }

        this.setState({deletingKnowledge: sourceFile});

        try {
            const idToken = await this.props.firebase.auth.currentUser.getIdToken();

            const body = {
                companyUid: useUID,
                sourceFile: sourceFile
            };

            // Add level-specific parameters based on the file's actual level
            if (level === 'campaignType' && levelId) {
                body.campaignType = levelId;
            } else if (level === 'campaign' && levelId) {
                body.campaignId = levelId;
            }

            const response = await fetch('https://europe-west3-digitalna-kartica.cloudfunctions.net/deleteKnowledgeChunks', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${idToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            const result = await response.json();

            if (response.ok && result.success) {
                alert(`Obrisano ${result.deletedCount} chunk(s).`);
                this.fetchKnowledgeFiles();
            } else {
                throw new Error(result.message || 'Greska pri brisanju');
            }
        } catch (error) {
            console.error('Error deleting knowledge:', error);
            alert('Greska pri brisanju: ' + error.message);
        } finally {
            this.setState({deletingKnowledge: null});
        }
    }

    handleFileSelect(event) {
        const file = event.target.files[0];
        if (file) {
            this.processSelectedFile(file);
        }
    }

    handleDragOver(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({isDragOver: true});
    }

    handleDragLeave(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({isDragOver: false});
    }

    handleFileDrop(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({isDragOver: false});

        const file = event.dataTransfer.files[0];
        if (file) {
            this.processSelectedFile(file);
        }
    }

    processSelectedFile(file) {
        // Check file type
        const allowedTypes = ['text/plain', 'text/csv', 'application/json'];
        const allowedExtensions = ['.txt', '.csv', '.json', '.md'];
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

        if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
            this.setState({
                knowledgeError: 'Nepodrzani format fajla. Podrzani formati: TXT, CSV, JSON, MD',
                selectedFile: null
            });
            return;
        }

        // Check file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
            this.setState({
                knowledgeError: 'Fajl je prevelik. Maksimalna velicina je 5MB.',
                selectedFile: null
            });
            return;
        }

        // Set file name as default title if empty
        const fileName = file.name.replace(/\.[^/.]+$/, ''); // Remove extension
        this.setState({
            selectedFile: file,
            knowledgeError: null,
            newKnowledgeTitle: this.state.newKnowledgeTitle || fileName
        });
    }

    async uploadKnowledgeFromFile() {
        const {selectedFile, newKnowledgeTitle, newKnowledgeCategory, knowledgeLevel, selectedCampaignType, selectedCampaignId, useManualCampaignId, manualCampaignId} = this.state;

        if (!selectedFile) {
            this.setState({knowledgeError: 'Molimo izaberite fajl.'});
            return;
        }

        if (!newKnowledgeTitle.trim()) {
            this.setState({knowledgeError: 'Naslov je obavezan.'});
            return;
        }

        // Validate level-specific requirements
        if (knowledgeLevel === 'campaignType' && !selectedCampaignType) {
            this.setState({knowledgeError: 'Izaberite tip kampanje.'});
            return;
        }

        // Get effective campaign ID (from dropdown or manual input)
        const effectiveCampaignId = useManualCampaignId ? manualCampaignId : selectedCampaignId;
        if (knowledgeLevel === 'campaign' && !effectiveCampaignId) {
            this.setState({knowledgeError: 'Izaberite ili unesite ID kampanje.'});
            return;
        }

        this.setState({uploadingKnowledge: true, knowledgeError: null});

        try {
            // Read file content
            const content = await this.readFileContent(selectedFile);

            if (!content || content.trim().length === 0) {
                throw new Error('Fajl je prazan');
            }

            const idToken = await this.props.firebase.auth.currentUser.getIdToken();

            const body = {
                companyUid: useUID,
                content: content,
                title: newKnowledgeTitle,
                category: newKnowledgeCategory,
                sourceFile: `file_${Date.now()}_${selectedFile.name.replace(/\s+/g, '_')}`
            };

            // Add level-specific parameters
            if (knowledgeLevel === 'campaignType') {
                body.campaignType = selectedCampaignType;
            } else if (knowledgeLevel === 'campaign') {
                body.campaignId = effectiveCampaignId;
            }

            const response = await fetch('https://europe-west3-digitalna-kartica.cloudfunctions.net/processKnowledgeContent', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${idToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            const result = await response.json();

            if (response.ok && result.success) {
                this.setState({
                    uploadingKnowledge: false,
                    newKnowledgeTitle: '',
                    newKnowledgeCategory: 'general',
                    selectedFile: null,
                    knowledgeError: null
                });
                alert(`Uspesno dodato ${result.chunksCreated} chunk(s) u bazu znanja.`);
                // Update view to match the level we just uploaded to
                this.setState({
                    viewLevel: knowledgeLevel,
                    viewCampaignType: selectedCampaignType,
                    viewCampaignId: effectiveCampaignId
                }, () => this.fetchKnowledgeFiles());
            } else {
                throw new Error(result.message || 'Greska pri uploadu');
            }
        } catch (error) {
            console.error('Error uploading knowledge from file:', error);
            this.setState({
                uploadingKnowledge: false,
                knowledgeError: 'Greska pri uploadu: ' + error.message
            });
        }
    }

    readFileContent(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.onerror = (e) => reject(new Error('Greska pri citanju fajla'));
            reader.readAsText(file, 'UTF-8');
        });
    }

    getCategoryLabel(category) {
        const labels = {
            'general': 'Opste',
            'product': 'Proizvod',
            'service': 'Usluga',
            'faq': 'FAQ',
            'policy': 'Politika',
            'promotion': 'Promocija'
        };
        return labels[category] || category;
    }

    getLevelLabel(level) {
        const labels = {
            'company': 'Kompanija (opste)',
            'campaignType': 'Tip kampanje',
            'campaign': 'Specificna kampanja'
        };
        return labels[level] || level;
    }

    render() {
        const {company, loading, knowledgeFiles, loadingKnowledge, uploadingKnowledge, campaigns, knowledgeLevel, selectedCampaignType, selectedCampaignId, viewLevel, viewCampaignType, viewCampaignId} = this.state;

        if (loading) {
            return (
                <div className="text-center py-8">
                    <Spinner animation="border" />
                    <p>Ucitavam...</p>
                </div>
            );
        }

        // Check if AI Knowledge Admin is enabled for this company
        if (!company?.allowAIKnowledgeAdmin) {
            return (
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 text-center">
                    <h3 className="text-lg font-semibold text-yellow-800 mb-2">AI Asistent nije aktiviran</h3>
                    <p className="text-yellow-700">
                        AI Asistent za kupce trenutno nije dostupan za vasu kompaniju.
                        Kontaktirajte nas za aktivaciju ove funkcionalnosti.
                    </p>
                </div>
            );
        }

        return (
            <div className="ai-knowledge-base">
                {/* Company Info */}
                {company && (
                    <div className="kb-company-header">
                        <h3>{company.name}</h3>
                        <p>Baza znanja za AI asistenta</p>
                    </div>
                )}

                {/* Test Users Section */}
                <div className="kb-test-users-section">
                    <div className="kb-test-users-header">
                        <h4>Test korisnici</h4>
                        <p className="kb-test-users-description">
                            Dodajte UID korisnika koji mogu testirati AI asistenta pre nego sto ga omogucite svim korisnicima.
                            Test korisnici ce videti "Pitaj AI" dugme u aplikaciji cak i kada <code>allowAIKnowledge</code> nije ukljucen.
                        </p>
                    </div>

                    <div className="kb-test-users-add">
                        <Form.Control
                            type="text"
                            placeholder="Unesite UID korisnika"
                            value={this.state.newTestUserUid}
                            onChange={(e) => this.setState({newTestUserUid: e.target.value})}
                            disabled={this.state.addingTestUser}
                        />
                        <Button
                            variant="primary"
                            onClick={this.addTestUser}
                            disabled={this.state.addingTestUser || !this.state.newTestUserUid.trim()}
                        >
                            {this.state.addingTestUser ? (
                                <Spinner animation="border" size="sm" />
                            ) : (
                                'Dodaj'
                            )}
                        </Button>
                    </div>

                    {this.state.testUsers.length > 0 ? (
                        <div className="kb-test-users-list">
                            {this.state.testUsers.map((uid) => (
                                <div key={uid} className="kb-test-user-item">
                                    <span className="kb-test-user-uid">{uid}</span>
                                    <button
                                        className="kb-test-user-remove"
                                        onClick={() => this.removeTestUser(uid)}
                                        disabled={this.state.removingTestUser === uid}
                                    >
                                        {this.state.removingTestUser === uid ? (
                                            <Spinner animation="border" size="sm" />
                                        ) : (
                                            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="kb-test-users-empty">Nema dodatih test korisnika.</p>
                    )}
                </div>

                {/* Info Box */}
                <div className="kb-info-box">
                    <div className="kb-info-icon">
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <div className="kb-info-content">
                        <h4>Hijerarhija znanja</h4>
                        <p>
                            AI asistent pretrazuje znanje po prioritetu:
                        </p>
                        <ol className="kb-hierarchy-list">
                            <li><strong>Specificna kampanja</strong> - znanje vezano za konkretnu ponudu (najvisi prioritet)</li>
                            <li><strong>Tip kampanje</strong> - znanje za sve kampanje istog tipa (npr. svi popusti)</li>
                            <li><strong>Kompanija (opste)</strong> - opste znanje o kompaniji, proizvodima, uslugama</li>
                        </ol>
                    </div>
                </div>

                {/* Add Knowledge Form */}
                <div className="kb-add-form">
                    <h4>Dodaj novo znanje</h4>

                    {this.state.knowledgeError && (
                        <div className="kb-error">{this.state.knowledgeError}</div>
                    )}

                    {/* Knowledge Level Selector */}
                    <Form.Group className="mb-3">
                        <Form.Label>Nivo znanja</Form.Label>
                        <div className="kb-level-selector">
                            <button
                                className={`kb-level-btn ${knowledgeLevel === 'company' ? 'active' : ''}`}
                                onClick={() => this.handleLevelChange('company')}
                            >
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                                Kompanija (opste)
                            </button>
                            <button
                                className={`kb-level-btn ${knowledgeLevel === 'campaignType' ? 'active' : ''}`}
                                onClick={() => this.handleLevelChange('campaignType')}
                            >
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                </svg>
                                Tip kampanje
                            </button>
                            <button
                                className={`kb-level-btn ${knowledgeLevel === 'campaign' ? 'active' : ''}`}
                                onClick={() => this.handleLevelChange('campaign')}
                            >
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                </svg>
                                Specificna kampanja
                            </button>
                        </div>
                    </Form.Group>

                    {/* Campaign Type Selector */}
                    {knowledgeLevel === 'campaignType' && (
                        <Form.Group className="mb-3">
                            <Form.Label>Tip kampanje</Form.Label>
                            {this.state.campaignTypes.length === 0 && !this.state.showAddCampaignType ? (
                                <div className="kb-no-types">
                                    <p>Nema definisanih tipova kampanja.</p>
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() => this.setState({showAddCampaignType: true})}
                                    >
                                        + Dodaj prvi tip
                                    </Button>
                                </div>
                            ) : (
                                <>
                                    <div className="kb-type-selector">
                                        <Form.Control
                                            as="select"
                                            value={selectedCampaignType}
                                            onChange={(e) => this.setState({selectedCampaignType: e.target.value})}
                                            disabled={this.state.showAddCampaignType}
                                        >
                                            <option value="">-- Izaberite tip --</option>
                                            {this.state.campaignTypes.map(type => (
                                                <option key={type} value={type}>{type}</option>
                                            ))}
                                        </Form.Control>
                                        {!this.state.showAddCampaignType && (
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => this.setState({showAddCampaignType: true})}
                                                title="Dodaj novi tip"
                                            >
                                                +
                                            </Button>
                                        )}
                                    </div>
                                    {this.state.showAddCampaignType && (
                                        <div className="kb-add-type">
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite naziv novog tipa..."
                                                value={this.state.newCampaignTypeInput}
                                                onChange={(e) => this.setState({newCampaignTypeInput: e.target.value})}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        this.addCampaignType();
                                                    }
                                                }}
                                            />
                                            <Button variant="primary" size="sm" onClick={this.addCampaignType}>
                                                Dodaj
                                            </Button>
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={() => this.setState({showAddCampaignType: false, newCampaignTypeInput: ''})}
                                            >
                                                Odustani
                                            </Button>
                                        </div>
                                    )}
                                </>
                            )}
                            <Form.Text className="text-muted">
                                Ovo znanje ce se koristiti za sve kampanje ovog tipa.
                            </Form.Text>
                        </Form.Group>
                    )}

                    {/* Campaign Selector */}
                    {knowledgeLevel === 'campaign' && (
                        <Form.Group className="mb-3">
                            <Form.Label>Kampanja</Form.Label>

                            {/* Toggle between dropdown and manual input */}
                            <div className="kb-campaign-mode-toggle">
                                <Form.Check
                                    type="radio"
                                    id="campaign-mode-select"
                                    label="Izaberi iz liste"
                                    checked={!this.state.useManualCampaignId}
                                    onChange={() => this.setState({useManualCampaignId: false, manualCampaignId: ''})}
                                />
                                <Form.Check
                                    type="radio"
                                    id="campaign-mode-manual"
                                    label="Unesi ID rucno"
                                    checked={this.state.useManualCampaignId}
                                    onChange={() => this.setState({useManualCampaignId: true, selectedCampaignId: ''})}
                                />
                            </div>

                            {!this.state.useManualCampaignId ? (
                                this.state.loadingCampaigns ? (
                                    <div className="text-muted p-2">Ucitavam kampanje...</div>
                                ) : campaigns.length === 0 ? (
                                    <div className="text-muted p-2">
                                        Nema kampanja. Unesite ID rucno.
                                    </div>
                                ) : (
                                    <Form.Control
                                        as="select"
                                        value={selectedCampaignId}
                                        onChange={(e) => this.setState({selectedCampaignId: e.target.value})}
                                    >
                                        <option value="">-- Izaberite kampanju (poslednjih 10) --</option>
                                        {campaigns.map(campaign => (
                                            <option key={campaign.id} value={campaign.id}>
                                                {campaign.offerPreview} {campaign.campaignType && `(${campaign.campaignType})`}
                                            </option>
                                        ))}
                                    </Form.Control>
                                )
                            ) : (
                                <Form.Control
                                    type="text"
                                    placeholder="Unesite Campaign ID..."
                                    value={this.state.manualCampaignId}
                                    onChange={(e) => this.setState({manualCampaignId: e.target.value.trim()})}
                                />
                            )}

                            <Form.Text className="text-muted">
                                {this.state.useManualCampaignId
                                    ? 'Copy/paste Campaign ID iz druge stranice aplikacije.'
                                    : 'Prikazane su poslednje kampanje. Za starije, unesite ID rucno.'}
                            </Form.Text>
                        </Form.Group>
                    )}

                    {/* Input Mode Toggle */}
                    <div className="kb-mode-toggle">
                        <button
                            className={`kb-mode-btn ${this.state.inputMode === 'file' ? 'active' : ''}`}
                            onClick={() => this.setState({inputMode: 'file', newKnowledgeContent: '', selectedFile: null})}
                        >
                            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                            </svg>
                            Upload fajla
                        </button>
                        <button
                            className={`kb-mode-btn ${this.state.inputMode === 'text' ? 'active' : ''}`}
                            onClick={() => this.setState({inputMode: 'text', selectedFile: null})}
                        >
                            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            Unos teksta
                        </button>
                    </div>

                    <Form.Group className="mb-3">
                        <Form.Label>Naslov</Form.Label>
                        <Form.Control
                            type="text"
                            value={this.state.newKnowledgeTitle}
                            onChange={(e) => this.setState({newKnowledgeTitle: e.target.value})}
                            placeholder="npr. Cenovnik proizvoda, O nama, Radno vreme..."
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Kategorija</Form.Label>
                        <Form.Control
                            as="select"
                            value={this.state.newKnowledgeCategory}
                            onChange={(e) => this.setState({newKnowledgeCategory: e.target.value})}
                        >
                            <option value="general">Opste informacije</option>
                            <option value="product">Proizvodi</option>
                            <option value="service">Usluge</option>
                            <option value="faq">Cesta pitanja</option>
                            <option value="policy">Politike i uslovi</option>
                            <option value="promotion">Promocije</option>
                        </Form.Control>
                    </Form.Group>

                    {/* File Upload Mode */}
                    {this.state.inputMode === 'file' && (
                        <Form.Group className="mb-3">
                            <Form.Label>Fajl</Form.Label>
                            <div
                                className={`kb-dropzone ${this.state.isDragOver ? 'drag-over' : ''} ${this.state.selectedFile ? 'has-file' : ''}`}
                                onDragOver={this.handleDragOver}
                                onDragLeave={this.handleDragLeave}
                                onDrop={this.handleFileDrop}
                                onClick={() => document.getElementById('kb-file-input').click()}
                            >
                                <input
                                    id="kb-file-input"
                                    type="file"
                                    accept=".txt,.csv,.json,.md"
                                    onChange={this.handleFileSelect}
                                    style={{display: 'none'}}
                                />
                                {this.state.selectedFile ? (
                                    <div className="kb-file-selected">
                                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="32" height="32">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        <span className="kb-file-name">{this.state.selectedFile.name}</span>
                                        <span className="kb-file-size">
                                            ({(this.state.selectedFile.size / 1024).toFixed(1)} KB)
                                        </span>
                                        <button
                                            className="kb-file-remove"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.setState({selectedFile: null});
                                            }}
                                        >
                                            Ukloni
                                        </button>
                                    </div>
                                ) : (
                                    <div className="kb-dropzone-content">
                                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="48" height="48">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                        </svg>
                                        <p>Prevucite fajl ovde ili kliknite za izbor</p>
                                        <span className="kb-dropzone-hint">Podrzani formati: TXT, CSV, JSON, MD (max 5MB)</span>
                                    </div>
                                )}
                            </div>
                        </Form.Group>
                    )}

                    {/* Text Input Mode */}
                    {this.state.inputMode === 'text' && (
                        <Form.Group className="mb-3">
                            <Form.Label>Sadrzaj</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={10}
                                value={this.state.newKnowledgeContent}
                                onChange={(e) => this.setState({newKnowledgeContent: e.target.value})}
                                placeholder={`Unesite tekst koji zelite da AI nauci. Npr:

iPhone 15 Pro - 1299 EUR
- Dostupne boje: Crna, Bela, Plava, Titan
- Memorija: 128GB, 256GB, 512GB, 1TB
- Garancija: 24 meseca

Radno vreme:
- Ponedeljak - Petak: 09:00 - 20:00
- Subota: 09:00 - 15:00
- Nedelja: Zatvoreno`}
                            />
                            <Form.Text className="text-muted">
                                AI ce automatski podeliti tekst na manje delove za efikasnije pretrazivanje.
                            </Form.Text>
                        </Form.Group>
                    )}

                    <Button
                        variant="primary"
                        onClick={this.state.inputMode === 'file' ? () => this.uploadKnowledgeFromFile() : this.uploadKnowledge}
                        disabled={uploadingKnowledge}
                        size="lg"
                    >
                        {uploadingKnowledge ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Dodajem...
                            </>
                        ) : (
                            'Dodaj u bazu znanja'
                        )}
                    </Button>
                </div>

                {/* Existing Knowledge List */}
                <div className="kb-list-section">
                    <div className="kb-list-header">
                        <h4>Postojece znanje</h4>

                        {/* View Level Filter */}
                        <div className="kb-view-filter">
                            <Form.Control
                                as="select"
                                value={viewLevel}
                                onChange={(e) => {
                                    this.setState({
                                        viewLevel: e.target.value,
                                        viewCampaignType: '',
                                        viewCampaignId: ''
                                    }, () => this.fetchKnowledgeFiles());
                                }}
                                className="kb-view-select"
                            >
                                <option value="company">Kompanija (opste)</option>
                                <option value="campaignType">Tip kampanje</option>
                                <option value="campaign">Specificna kampanja</option>
                            </Form.Control>

                            {viewLevel === 'campaignType' && (
                                <Form.Control
                                    as="select"
                                    value={viewCampaignType}
                                    onChange={(e) => this.setState({viewCampaignType: e.target.value}, () => this.fetchKnowledgeFiles())}
                                    className="kb-view-select"
                                >
                                    <option value="">-- Izaberite tip --</option>
                                    {this.state.campaignTypes.map(type => (
                                        <option key={type} value={type}>{type}</option>
                                    ))}
                                </Form.Control>
                            )}

                            {viewLevel === 'campaign' && (
                                <Form.Control
                                    as="select"
                                    value={viewCampaignId}
                                    onChange={(e) => this.setState({viewCampaignId: e.target.value}, () => this.fetchKnowledgeFiles())}
                                    className="kb-view-select"
                                >
                                    <option value="">-- Izaberite kampanju --</option>
                                    {campaigns.map(campaign => (
                                        <option key={campaign.id} value={campaign.id}>
                                            {campaign.offerPreview} {campaign.campaignType && `(${campaign.campaignType})`}
                                        </option>
                                    ))}
                                </Form.Control>
                            )}
                        </div>
                    </div>

                    <div className="kb-view-label">
                        Prikazujem: <strong>{this.getLevelLabel(viewLevel)}</strong>
                        {viewLevel === 'campaignType' && viewCampaignType && (
                            <span> - {viewCampaignType}</span>
                        )}
                        {viewLevel === 'campaign' && viewCampaignId && (
                            <span> - {campaigns.find(c => c.id === viewCampaignId)?.offerPreview || viewCampaignId}</span>
                        )}
                    </div>

                    {loadingKnowledge ? (
                        <div className="text-center py-4">
                            <Spinner animation="border" />
                            <p>Ucitavam...</p>
                        </div>
                    ) : knowledgeFiles.length === 0 ? (
                        <div className="kb-empty">
                            <div className="kb-empty-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                            </div>
                            <p>Nema znanja na ovom nivou.</p>
                            <p className="text-muted">Dodajte znanje iznad da bi AI asistent mogao da odgovara na pitanja kupaca.</p>
                        </div>
                    ) : (
                        <div className="kb-list">
                            {knowledgeFiles.map((file, index) => (
                                <div key={index} className="kb-card">
                                    <div className="kb-card-header">
                                        <h5>{file.title}</h5>
                                        <div className="kb-card-badges">
                                            {file.level && (
                                                <span className={`kb-level-badge level-${file.level}`}>
                                                    {file.level === 'company' && 'Kompanija'}
                                                    {file.level === 'campaignType' && `Tip: ${file.levelDisplayName}`}
                                                    {file.level === 'campaign' && `Kampanja: ${file.levelDisplayName}`}
                                                </span>
                                            )}
                                            <span className={`kb-category category-${file.category}`}>
                                                {this.getCategoryLabel(file.category)}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="kb-card-info">
                                        <span className="kb-chunks">
                                            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h7" />
                                            </svg>
                                            {file.chunksCount} delova
                                        </span>
                                        {file.createdAt && (
                                            <span className="kb-date">
                                                Dodato: {file.createdAt.toDate ?
                                                    new Date(file.createdAt.toDate()).toLocaleDateString('sr-RS') :
                                                    'N/A'}
                                            </span>
                                        )}
                                    </div>
                                    <div className="kb-card-actions">
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() => this.deleteKnowledge(file.sourceFile, file.level, file.levelId)}
                                            disabled={this.state.deletingKnowledge === file.sourceFile}
                                        >
                                            {this.state.deletingKnowledge === file.sourceFile ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                'Obrisi'
                                            )}
                                        </Button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const condition = authUser => !!authUser;
const AIKnowledgeBaseContent = withFirebase(AIKnowledgeBaseContentBase);

export default withAuthorization(condition)(AIKnowledgeBasePage);
